import $axios from '@/axios-instance.js'

export const resellerService = {
  getAll,
  getListData,
  getById,
  create,
  update,
  delete: _delete
}

let cancellationSource

function getAll () {
  return $axios.get(`${process.env.ROOT_API}/resellers/get-all`).then(response => {
    return response.data
  })
}

function getListData (filter, page) {
  if (cancellationSource) {
    cancellationSource.cancel('cancel previous request')
  }

  const CancelToken = $axios.CancelToken
  cancellationSource = CancelToken.source()

  return $axios.get(`${process.env.ROOT_API}/resellers`, {
    params: Object.assign({ currentPage: page }, filter),
    cancelToken: cancellationSource.token
  })
    .then(response => {
      return response.data
    })
}

function getById (id) {
  return $axios.get(`${process.env.ROOT_API}/resellers/${id}`).then(response => {
    return response.data
  })
}

function create (reseller) {
  return $axios.post(`${process.env.ROOT_API}/resellers`, reseller).then(response => {
    return response.data
  })
}

function update (reseller) {
  return $axios.put(`${process.env.ROOT_API}/resellers/${reseller.resellerId}`, reseller).then(response => {
    return response.data
  })
}

function _delete (id) {
  return $axios.delete(`${process.env.ROOT_API}/resellers/${id}`).then(response => {
    return response.data
  })
}



// WEBPACK FOOTER //
// ./src/services/reseller.service.js